import { render, staticRenderFns } from "./CreateVote.vue?vue&type=template&id=32b207d1&scoped=true"
import script from "./CreateVote.vue?vue&type=script&lang=js"
export * from "./CreateVote.vue?vue&type=script&lang=js"
import style0 from "./CreateVote.vue?vue&type=style&index=0&id=32b207d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b207d1",
  null
  
)

export default component.exports